/**
 * Initializes Vue components.
 */
// Init Vue.
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';

Vue.use(VueCompositionAPI);

window.Vue = Vue;

document.addEventListener('DOMContentLoaded', () => {
    if( !$('.vue-app').length ) {
        return;
    }

    // Init vue app.
    window.vueApp = new Vue({
        el: '.vue-app'
    });
});
